import { NewUser } from './../../model/newUser';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ApiEndpoints, Grades, CookieNames, BasicRoutes, PaymentSteps } from './../../constant';
import { ShoppingCartService, HttpClientService, emailValidator, mobileValidator, emptyField, CookieManagerService, ErrorManagerService, CustomObserverService, RegistrationFeeTokenService } from '../../../shared';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../../model/index';
import swal from 'sweetalert2';

@Component({
  selector: 'app-billing-info',
  templateUrl: '../views/billing-info.component.html',
})
export class BillingInfoComponent implements OnInit {

  public districts: Array<Object> = [];
  public totalPrice: number = 0;
  public lengthItems: number = 0;
  public billingInfo: FormGroup;
  public grades: Array<Object> = [];
  public user: NewUser = new NewUser({});
  public billingMobile: string = null;
  public apiRequstWaiter: boolean = true;

  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private httpClientService: HttpClientService,
    public fb: FormBuilder,
    private cookieManagerService: CookieManagerService,
    private translateService: TranslateService,
    private errorManagerService: ErrorManagerService,
    private customObserverService: CustomObserverService,
    private registrationFeeTokenService : RegistrationFeeTokenService,

  ) {
    this.billingInfo = fb.group({
      'firstName': ['', Validators.compose([Validators.required, emptyField])],
      'lastName': ['', Validators.compose([Validators.required, emptyField])],
      'grade': ['', Validators.compose([Validators.required])],
      'district': ['', Validators.compose([Validators.required])],
      'mobile': ['', Validators.compose([Validators.required, mobileValidator])]
    });
    this.shoppingCartService.getItemsLength()
      .subscribe(res => {
        if (res != null) {
          this.lengthItems = res.length;
          if (this.lengthItems == 0) {
            this.router.navigate(['home/exams']);
          }
        }
      });
  }

  ngOnInit() {
    //billing component
    this.customObserverService.setPaymentFlowIcon(PaymentSteps.billingDetails);
    this.loadDistricts();
    this.grades = Grades;
    this.getUserById();
    window.scrollTo(0, 0);
  }

  /**
   *
   * load districts
   * @memberof BillingInfoComponent
   */
  loadDistricts() {
    this.httpClientService.get(ApiEndpoints.getDistricts).subscribe(response => {
      this.districts = response;
    }, error => {

    });
  }

  /**
   *
   * update user info
   * @memberof BillingInfoComponent
   */
  updateUser() {
    this.apiRequstWaiter = false;
    this.user.setting.mobile.push({ 'data': this.billingMobile });
    this.httpClientService.authPaymentPut(ApiEndpoints.updateUser, this.user).subscribe(response => {
      this.router.navigate([BasicRoutes.paymentOptions]);
      this.customObserverService.setPaymentFlowIcon(PaymentSteps.paymentOptions);
      this.shoppingCartService.getPageStatus()
        .subscribe(res => {
          if (res) {
            this.apiRequstWaiter = res;
          }
        });
    }, error => {
      this.apiRequstWaiter = false;
      if (error.json().code === 4022) {
        swal({
          title: this.translateService.instant('SW_HEAD2'),
          html: this.translateService.instant('SW_BODY2'),
          type: 'error'
        });
      } else {
        this.errorManagerService.setError(error);
      }
    });
  }
  /**
   * get User By Id
   * @param {any} id
   * @memberof BillingInfoComponent
   */
  getUserById() {
    let id = this.cookieManagerService.getCookie(CookieNames.username, false);
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);

    let user = userObj ? JSON.parse(userObj.toString()) : null;
    if(user){
      id = user._id;
    }
    id ? true: id = this.registrationFeeTokenService.getRegistrationToken();
    if (id) {
      this.user._id = id;
      this.httpClientService.authPaymentGet(ApiEndpoints.getUserById, null).subscribe(response => {

        this.user = new NewUser(response.user);
        if (this.user.setting.mobile && this.user.setting.mobile.length > 0) {
          this.billingMobile = this.user.setting.mobile[this.user.setting.mobile.length - 1].data;
        }
        else {
          this.billingMobile = this.user.mobile;
        }
        if (!this.user.grade) {
          this.user.grade = "";
        }
        if (!this.user.district) {
          this.user.district = "";
        }

      }, error => {
        if (error.json().code === 4022) {
          swal({
            title: this.translateService.instant('SW_HEAD2'),
            html: this.translateService.instant('SW_BODY2'),
            type: 'error'
          });
        } else {
          this.errorManagerService.setError(error);
        }
      }
      );

    }

  }

  /**
   *
   * Back to checkout
   * @memberof BillingInfoComponent
   */
  backTocheckout() {
    this.router.navigate([BasicRoutes.checkout]);
    this.customObserverService.setPaymentFlowIcon(PaymentSteps.cart);

  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/checkout/components/billing-info.component.ts